<template>
  <div class="web-nav-wrap">
    <Row id="web-nav-list-wrap">
      
      <!-- <Col class="web-nav-item-wrap" span="2">
        <ul class="web-nav-item">
          <li><a href="/" target="_self">协会首页</a></li>
        </ul>
      </Col>
      <Col class="web-nav-item-sep" span="2"></Col> -->
      <Col class="web-nav-item-wrap" v-for="(topMenu, topIndex) in topMenus" v-bind:key="topIndex">
        <ul class="web-nav-item">
          <li>
            <router-link tag="a" v-if="topMenu.menuType=='page'" :to="{path: topMenu.menuLink, query: {sid: website}}" @click.native="flushCome">{{topMenu.menuName}}</router-link>
            <router-link tag="a" v-else-if="topMenu.menuType=='list'" :to="{path: topMenu.menuLink, query: {colid: topMenu.menuId, sid: website}}" @click.native="flushCome">{{topMenu.menuName}}</router-link>
          </li>
          
          <div v-if="subMenus[topMenu.id]!=null">
            <li v-for="(subMenu, subIndex) in subMenus[topMenu.id]" v-bind:key="subIndex" >
              <router-link tag="a" v-if="subMenu.menuType=='list'" :to="{path: subMenu.menuLink, query: {colid: subMenu.menuId, sid: website}}" @click.native="flushCome">{{subMenu.menuName}}</router-link>
              <router-link tag="a" v-else-if="subMenu.menuType=='page'" :to="{path: subMenu.menuLink, query: {sid: website}}" @click.native="flushCome">{{subMenu.menuName}}</router-link>
              <a v-else-if="subMenu.menuType=='link'" :href="subMenu.menuLink" target="_blank">{{subMenu.menuName}}</a>
            </li>
          </div>
          <div class="manu-bottom-border"></div>
        </ul>
      </Col>
      
    </Row>
  </div>
</template>
<script>
import axios from "axios"
export default {
  data() {
    return {
      website: 0,
      topMenus: [],
      subMenus: []
    }
  },

  //页面加载完成执行
  mounted() {
    this.initPageData()

    this.initMenus()
  },

  //页面方法
  methods: {
    //初始化页面数据
    initPageData() {
      let sid = parseInt(this.$route.query.sid)
      if(!isNaN(sid) && sid>1) {
        this.website = sid
      } else {
        this.website = 0
      }
    },

    //初始化页面图片数据
    initMenus() {
      let vm = this
      axios.post(
        vm.GLOBAL_API.apiUrl + "/index/web-menus",
        {site: vm.website, status: 1},
        {
          headers: {
            'content-type': 'application/json'
          }
        }
      ).then(function(res) {
        let errorCode = parseInt(res.data.code)
        if(!isNaN(errorCode) && errorCode==0) {
          vm.topMenus = res.data.data.topMenus
          vm.subMenus = res.data.data.subMenus
          vm.website = res.data.data.associationId
        }
      }).catch(function(error) {
        console.log(error)
      });
    },

    //生成URL
    generateUrl(pattern, pageType) {
      console.log(pageType)
      return this.$router.resolve(pattern).href+"&"+Math.random()
    },

    //刷新页面
    flushCome(){
      this.$router.go(0);  
    },
  }

}
</script>